import { IKImage } from "imagekitio-next";
import React from "react";

type BigCardThumbnailProps = {
  imageName: string;
  alt: string;
};
const urlEndpoint = process.env.NEXT_PUBLIC_BASE_IMAGE_KIT_URL;
const BigCardThumbnailUrlWidth = 700;
const BigCardThumbnailUrlHeight = 300;
const BigCardThumbnailUrlQuality = 70;
const BigCardThumbnail = (props: BigCardThumbnailProps) => {
  return (
    <IKImage
      urlEndpoint={urlEndpoint}
      path={props?.imageName || "default_image.jpg"}
      quality={BigCardThumbnailUrlQuality}
      width={BigCardThumbnailUrlWidth}
      height={BigCardThumbnailUrlHeight}
      alt={props?.alt}
      lqip={{ active: true, quality: 20 }}
      loading="lazy"
      className="rounded-[55px] w-full h-full object-cover"
      style={{ height: "100%", width: "100%" }}
    />
  );
};

export default BigCardThumbnail;
